// extracted by mini-css-extract-plugin
var _1 = "ColorPickerPopoverActions-moduleactions__Xsbzm";
export { _1 as "actions" }
